import { createAction, createAsyncAction } from 'typesafe-actions';

import {
  PendingTermsAgreementTypes,
  TermsAgreementTypes,
  TermsListTypes,
} from './types';

export const pendingTermsAgreementCount = createAsyncAction(
  'users/pendingTermsAgreementCount/request',
  'users/pendingTermsAgreementCount/success',
  'users/pendingTermsAgreementCount/failure',
)<undefined, { data: TermsAgreementTypes }, undefined>();

export const pendingTermsAgreement = createAsyncAction(
  'users/pendingTermsAgreement/request',
  'users/pendingTermsAgreement/success',
  'users/pendingTermsAgreement/failure',
)<undefined, { data: PendingTermsAgreementTypes[] }, undefined>();

export const termsAgreementAccept = createAsyncAction(
  'users/termsAgreementAccept/request',
  'users/termsAgreementAccept/success',
  'users/termsAgreementAccept/failure',
)<undefined, undefined, undefined>();

export const termsLists = createAsyncAction(
  'users/termsLists/request',
  'users/termsLists/success',
  'users/termsLists/failure',
)<undefined, { data: TermsListTypes[] }, undefined>();

export const donwloadTerms = createAsyncAction(
  'users/donwloadTerms/request',
  'users/donwloadTerms/success',
  'users/donwloadTerms/failure',
)<undefined, undefined, undefined>();

export const clearTermsAgreement = createAction(
  'users/clearTermsAgreement',
)<undefined>();
